import "../styles/A.css";
import Jatmetal from "../images/jatmetal1.png";
export default function AboutUs() {
  return (
    <>
      {" "}
      {/* HERO */}{" "}
      <section className="about-hero">
        {" "}
        <div className="container">
          {" "}
          <h1>About Jat Technocraft</h1>{" "}
          <p>
            {" "}
            Company Profile: Since 2015, we have been setting benchmarks in air
            conditioner manufacturing excellence at MIDC Waluj, Chhatrapati Sambhajinagar.{" "}
          </p>{" "}
        </div>{" "}
      </section>{" "}
      {/* WHO WE ARE */}{" "}
      <section className="about-section">
        {" "}
        <div className="container">
          {" "}
          <div className="about-wrapper">
            {" "}
            {/* LEFT IMAGE */}{" "}
            <div className="about-image">
              {" "}
              <img src={Jatmetal} alt="Manufacturing Unit" />{" "}
            </div>{" "}
            {/* RIGHT CONTENT */}{" "}
            <div className="about-card">
              {" "}
              <h2>Who We Are</h2>{" "}
              <p>
                {" "}
                Jat Technocraft Pvt. Ltd. is a leading manufacturing
                organization engaged in air conditioner job work and OEM
                manufacturing services. Established in 2015, our facility at
                MIDC Waluj, Chhatrapati Sambhajinagar is equipped with modern production lines,
                quality testing systems, and SOP-driven processes.{" "}
              </p>{" "}
              <p>
                {" "}
                We proudly support reputed brands such as{" "}
                <b> Voltas, Hyundai, and Kenstar</b>.{" "}
              </p>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </section>{" "}
      {/* VISION */}{" "}
      <section className="vision-section">
        {" "}
        <div className="container">
          {" "}
          <h2>🌟 Our Vision</h2>{" "}
          <div className="vision-grid">
            {" "}
            <div className="vision-card">
              {" "}
              <div className="icon">🎯</div> <h3>Global Leadership</h3>{" "}
              <p>
                {" "}
                To become a globally trusted OEM manufacturing partner in HVAC
                industry.{" "}
              </p>{" "}
            </div>{" "}
            <div className="vision-card">
              {" "}
              <div className="icon">⚙</div> <h3>Innovation</h3>{" "}
              <p>
                {" "}
                Driven by innovation and continuous technological
                improvement.{" "}
              </p>{" "}
            </div>{" "}
            <div className="vision-card">
              {" "}
              <div className="icon">🏭</div> <h3>Quality Excellence</h3>{" "}
              <p>
                {" "}
                Ensuring highest manufacturing standards and precision
                output.{" "}
              </p>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </section>{" "}
    </>
  );
}
